import { encryptJson } from "@/helpers/crypto/crypto";

export async function saveAuthData(user) {
  localStorage.setItem("token", user.token);
  localStorage.setItem("avatar", user.avatar);
  localStorage.setItem("fullName", user.fullName);
  const encrypted = await encryptJson(user);
  localStorage.setItem("dataUser", encrypted);

  const firstMenu = user.categoryMenu && user.categoryMenu[0] && user.categoryMenu[0].menus[0];
  if (firstMenu) {
    const menuPath =
      firstMenu.subMenus && firstMenu.subMenus.length > 0
        ? firstMenu.subMenus[0].path
        : firstMenu.path;
    localStorage.setItem("menuPath", menuPath);
    return menuPath;
  }
  return "/dashboard";
}
